<template id="main-page">
  <v-ons-page>
    <v-ons-toolbar>
      <div class="center">Clientes</div>
    </v-ons-toolbar>
        <p style="text-align: center; font-size:95%; font-weight:bold">
        <v-ons-search-input v-model="nome" placeholder="Filtrar"/>
        </p>
     <v-ons-card>
    <div class="content">
    <p style="text-align: center; font-size:95%; font-weight:bold">
    <v-ons-list>
        <ons-gesture-detector>
        <v-ons-list-item v-for="item of filterclientes" :key="item.codEmitente">
            <div @click="Action(item['cgc'])" class="center"> 
                {{item['nome-emit']}}
                <br>
                {{item['nome-matriz']}}
                <br>
                {{item['cgc']}}
            </div>
        </v-ons-list-item>
        </ons-gesture-detector>   
  </v-ons-list>
    </p>
</div>
 </v-ons-card>
    <v-ons-action-sheet :visible.sync="actionSheetVisible" cancelable>
      <v-ons-action-sheet-button icon="md-plus" @click="orcamento()">Novo Orçamento</v-ons-action-sheet-button>
      <v-ons-action-sheet-button icon="md-store" @click="detalhes()">Detalhes</v-ons-action-sheet-button>
      <v-ons-action-sheet-button icon="md-close" @click="dismiss()">Cancelar</v-ons-action-sheet-button>
    </v-ons-action-sheet>
  </v-ons-page>
</template>

<style>
  /* CSS goes here */
</style>

<script>
import { mapGetters } from 'vuex'
import store from '../store/index.js'
import erp from '../services/erp.js'

export default {

  data(){
    return {
      clientes: [],
      nome: '',
      cliId: '',
      pageOfItems: [],
      codrep: '',
      admin: false,
      cli: '',
      actionSheetVisible: false,
      timeoutID: 0

       }
  },
  mounted(){
    erp.listar(localStorage.getItem('codrep')).then(resposta => {
      this.clientes = resposta.data
      })
  },
  name: 'Users',
  computed: mapGetters([
    'isAdmin',
    'isRepres',
  ]),
  computed: {
    filterclientes: function() {
      const lNome = this.nome.toLowerCase()
      
      return this.clientes.filter((cliente) => {
        return cliente['nome-emit'].toLowerCase().match(lNome) || cliente['cgc'].toLowerCase().match(lNome) || cliente['nome-matriz'].toString().toLowerCase().match(lNome)
      })
    }
    },
    methods: {
    detalhes: function (e) {
        this.$router.push('/clientes/' + e)
      },
      Action(cgc) {
          this.cli = cgc
          this.actionSheetVisible = true
      },
      orcamento: function () {
        this.$router.push('/orcamento/' + this.cli + '/1')
      },
      dismiss(){
        this.actionSheetVisible = false
      },
      detalhes(){
        this.$router.push('/detalhecliente/' + this.cli)
      }
    }
  }
</script>